import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { RequestUserTaskUpdateVisibility } from '@shared/dto/user_task/_requests/request_user_task_update_visibility';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../../_base/createAsyncThunkSafe';
import { STATE__generation } from '../../STATE__generation';

export const remote_user_task_update_visibility = createAsyncThunkSafe<void, RequestUserTaskUpdateVisibility>(
  ENUM__network_event_client_to_server.USER_TASK_UPDATE_VISIBILITY,
  async (request, thunkApi): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.USER_TASK_UPDATE_VISIBILITY, request);
  },
);

export function init_remote_user_task_update_visibility(builder: ActionReducerMapBuilder<STATE__generation>) {
  builder
    .addCase(remote_user_task_update_visibility.pending, (state, action) => {
      let request = action.meta.arg;

      let user_task = state.user_tasks_map.get_or_assert(request.user_task_id, { context: 'user_task' });

      user_task = user_task.clone({ is_hidden: request.is_hidden });
      state.user_tasks_map.set(user_task._id, user_task);
    })
    .addCase(remote_user_task_update_visibility.rejected, (state, action) => {})
    .addCase(remote_user_task_update_visibility.fulfilled, (state, action: PayloadAction) => {});
}
